// extracted by mini-css-extract-plugin
module.exports = {"componentsButton":"styles_componentsButton__AxJIv"};